module.exports = __webpack_public_path__ + "static/media/site_banner.0af7cc32.png";